import React from 'react';
import { 
    Create, 
    SimpleForm, 
    FileInput, 
    FileField, 
    required,
    SaveButton, 
    Toolbar
} from 'react-admin';
import ExcelTemplateButton from '../Button/ExcelTemplate/ExcelTemplateButton';

const PostCreateToolbar = props => (
    <Toolbar {...props}>
        <SaveButton />
        <ExcelTemplateButton
            dataTemplate="UPLOAD_AGENT"
        />
    </Toolbar>
);

export default props => (
    <Create {...props}>
        <SimpleForm 
            toolbar={<PostCreateToolbar />}
            redirect="list">
            <FileInput
                source="upload"
                label="Upload Agent"
                validate={[required()]}
            >
                <FileField
                    source="src"
                    title="title"
                />
            </FileInput>
        </SimpleForm>
    </Create>
);